import { Container } from "@mui/material";
import React from "react";
import SectionHeader from "../components/SectionHeader";
import * as textBodyMessage from "../Services/textBody";
import ProjectContainer from "./ProjectContainer";

function Project(props) {
  return (
    <Container maxWidth="lg" sx={{ minHeight: "100vh" }} id="project-container">
      <SectionHeader
        sectionTitle={textBodyMessage.project.pageTitle.toUpperCase()}
      />
      <ProjectContainer projects={textBodyMessage.projectList} />
    </Container>
  );
}

export default Project;
